interface IIcon {
  width?: string;
  height?: string;
}

const CheckedIcon = ({ height, width }: IIcon) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11461_3976)">
      <path
        d="M6 0C2.69173 0 0 2.69173 0 6C0 9.30827 2.69173 12 6 12C9.30827 12 12 9.30827 12 6C12 2.69173 9.30827 0 6 0ZM9.35338 4.42105L5.5188 8.22556C5.29323 8.45113 4.93233 8.46617 4.69173 8.2406L2.66165 6.39098C2.42105 6.16541 2.40602 5.78947 2.61654 5.54887C2.84211 5.30827 3.21805 5.29323 3.45865 5.5188L5.06767 6.99248L8.49624 3.56391C8.73684 3.32331 9.11278 3.32331 9.35338 3.56391C9.59399 3.80451 9.59399 4.18045 9.35338 4.42105Z"
        fill="#94C947"
      />
    </g>
    <defs>
      <clipPath id="clip0_11461_3976">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CheckedIcon;
